const environment = "test";

export const DriverDetailsAndTrackingDatas = {
  intro: `This API provides driver details, including the driver's name, country code, and contact number, along with a tracking link for a booking associated with a given bookingId. The bookingId is obtained from the "Booking With Vehicle" API after the booking is confirmed.`,

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/apiDriverTracking?bookingId=bookingId&email=email`
      : `https://api.drivado.com/api/v1/api/apiDriverTracking?bookingId=bookingId&email=email`,

  responseDes: (
    <div className="space-y-2">
      <div>
        For a successful request, the API returns the driver details along with
        the generated tracking link only if the tracking gets started.
      </div>
      <div>
        In case of a failed request, the API returns a status code 400 along
        with the driver details and a message stating "Tracking Link not yet
        generated.
      </div>
    </div>
  ),
};
